export const voidFn = () => {};
